import styled from 'styled-components';
import { media, colors, mixins } from '../../css';
import Text from '../Text';
import SVGIcon from '../../SVGIcon/SVGIcon';

export const StyledButton = styled.button`
  background-color: ${colors.colorWhite};
  border-radius: ${mixins.pxToRem(2)};
  padding: ${mixins.pxToRem(8)} 0 ${mixins.pxToRem(6)};
  outline: none;
  display: inline-block;
  vertical-align: middle;
  margin: 0 ${mixins.pxToRem(8)};
  width: calc(50% - 16px);
  cursor: pointer;
  ${media.greaterThan('lg')`
    width: auto;
    padding: ${mixins.pxToRem(8)} ${mixins.pxToRem(25)} ${mixins.pxToRem(6)};
  `};
`;

export const StyledButtonText = styled(Text.CopyBody)`
  display: inline-block;
  vertical-align: middle;
`;

export const StyledIcon = styled(SVGIcon)`
  display: inline-block;
  vertical-align: middle;
  margin-left: ${mixins.pxToRem(8)};
`;
